export const locationsData = [
  {
    locationName: "Chhattisgarh",
    title: "MBBS in Chhattisgarh	",
    metaTitle: "MBBS Admission in Chhattisgarh 2026 | Counselling India",
    metaDescription:
      "Get MBBS Admission in Chhattisgarh 2026 with expert counselling support from Counselling India. Call today: 9730858444.",
    metaKeywords: "MBBS in Chhattisgarh  in 2026",
    secondHeading: "Complete Guide for 2026 Aspirants",
    secondPara: ` <b>Chhattisgarh</b> one of India’s newer yet rapidly
                  developing states, has become a favorable destination for
                  <b> MBBS aspirants</b>. With well-structured medical education
                  infrastructure, increasing seat availability, and
                  government-supported policies, Chhattisgarh offers an
                  accessible and transparent route to aspiring doctors. This
                  guide provides a comprehensive overview of
                  <span className="text-[#f78c1f] font-[500]">
                    MBBS admission in Chhattisgarh
                  </span>
                  , including <b>management quota admissions,</b> direct
                  <b>MBBS options</b>, and a list of <b>top medical colleges</b>
                  in the state.`,
    thirdHeading: ` Overview of <b>MBBS in Chhattisgarh</b>`,
    thirdPara: `    MBBS (Bachelor of Medicine and Bachelor of Surgery) is a
                    five-and-a-half-year professional undergraduate medical
                    program that includes one year of mandatory internship. The
                    program is governed by the
                    <b>National Medical Commission (NMC)</b>, and the
                    <b>
                    
                      Directorate of Medical Education, Chhattisgarh (DME-CG)
                    </b>
                    is responsible for admissions in the state.`,
    fourthPara: `    With around <b> 1,500+ MBBS</b> seats in both government
                      and private colleges, Chhattisgarh offers a competitive
                      yet attainable route to a medical career, especially for
                      NEET-qualified candidates from across India.`,
    eligibilityCriteria: [
      {
        icon: "line-icon-Male-2 text-gradient bg-[#194297]",
        title: "Age:",
        content:
          "Minimum of 17 years as of 31st December of the admission year",
      },
      {
        icon: "line-icon-Book text-gradient bg-[#194297]",
        title: "Academic Qualification",
        content:
          "10+2 or equivalent with Physics, Chemistry, Biology/Biotechnology, and English.",
      },
      {
        icon: " line-icon-Target text-gradient bg-[#194297]",
        title: "Minimum Marks:",
        content: "General category: 50% in PCB,  OBC/SC/ST: 40%, PwD: 45%",
      },
      {
        icon: "line-icon-University-2 text-gradient bg-[#194297]",
        title: "NEET-UG Qualification",
        content:
          "Mandatory for all categories, including management and NRI quotas",
      },
    ],
    fifthHeading: " Admission Process for MBBS in Chhattisgarh",
    fifthPara: `    The <b>MBBS admission in Chhattisgarh </b>is conducted through
                centralized online counselling managed by the Directorate of
                Medical Education, Raipur (CGDME) via the official portal
                <a
                  className="mx-2 text-blue-500"
                  href="https://cgdme.admissions.nic.in."
                >
                  https://cgdme.admissions.nic.in.
                </a>`,
    firstOlHeading: "Seat Categories:",
    firstOl: [
      {
        title: "State Quota (85%)",
        description: "For Chhattisgarh domicile students.",
      },
      {
        title: "All India Quota (15%)",
        description: "Conducted by MCC for government colleges.",
      },
      {
        title: "NRI Quota",
        description:
          "Reserved for foreign nationals and NRIs in some private colleges.",
      },
    ],
    secondOlHeading: "Steps in the Admission Process:",
    secondOl: [
      {
        title: "NEET Qualification",
        description: "Appear and qualify in NEET-UG.",
      },
      {
        title: "Online Registration",
        description: "Register on CGDME portal for counselling.",
      },
      {
        title: "Document Verification",
        description: "Online or offline as notified.",
      },
      {
        title: "Choice Filling",
        description:
          "Select preferred colleges and quota (government, private, management).",
      },
      {
        title: "Seat Allotment",
        description: "Based on NEET rank, category, and availability.",
      },
      {
        title: "Reporting & Fee Payment",
        description: "Confirm seat and join the allotted college.",
      },
    ],

    sixthHeading: "MBBS Admission Through Management Quota in Chhattisgarh",
    sixthPara:
      " Private medical colleges in Chhattisgarh offer management quota seats, providing a valuable option for students who have qualified NEET but have lower ranks.",
    thirdOlHeading: "Key Features:",
    thirdOl: [
      {
        title: "Open to All India Candidates",
        description: "No domicile requirement.",
      },
      {
        title: "NEET Mandatory",
        description:
          "Even under management quota, NEET qualification is compulsory.",
      },
      {
        title: "Higher Fee Structure",
        description:
          "Typically higher than government and regular private seats.",
      },
      {
        title: "Transparent Counselling",
        description: "Conducted via the same CGDME portal.",
      },
    ],
    fourthOlHeading: "Required Documents:",
    fourthOl: [
      "NEET-UG scorecard",
      "Class 10 and 12 mark sheets and certificates",
      "Transfer and migration certificate",
      "ID proof (Aadhaar/Passport)",
      "Passport-size photographs",
      "Domicile certificate (if applicable)",
      "Category and income certificates (if applicable)",
    ],
    fourthOlNote: `   Management quota seats are filled through counseling, not direct
                negotiation with colleges. Always apply through official
                portals.`,
    sevenHeading: "   Direct MBBS Admission in Chhattisgarh",
    sevenPara: `   <b> “Direct MBBS Admission” </b>usually refers to securing a
                  seat without the regular merit-based competition, commonly
                  through management or NRI quotas. However, NEET qualification
                  is still mandatory.`,

    fifthOlHeading: "  How Direct Admission Works:",
    fifthOl: [
      "Available only in private medical colleges.",
      "Seats that remain vacant after initial counselling rounds may be offered directly.",
      "Admission facilitated by college-authorized admission desks or counselling consultants, but still must be reported through the CGDME system.",
      "Fees are payable upfront and are generally non-refundable.",
    ],
    eighthHeading: "  Top Medical Colleges in Chhattisgarh",
    eighthPara: ` Chhattisgarh has both reputed government and private medical
                institutions. Here’s a look at the best options for MBBS
                aspirants:`,
    sixthOlHeading: "Top Government Medical Colleges:",
    sixthOl: [
      {
        name: "Pt. Jawahar Lal Nehru Memorial Medical College, Raipur",
        points: [
          "Premier government institution with strong academics and clinical exposure.",
          "High patient inflow and excellent faculty.",
        ],
      },
      {
        name: "Government Medical College, Bilaspur",
        points: [
          "Established recently but fast-growing in reputation.",
          "Good facilities and practical training.",
        ],
      },
      {
        name: "Late Baliram Kashyap Memorial Medical College, Jagdalpur",
        points: [
          "Serves tribal regions; good clinical exposure and public health training.",
        ],
      },
      {
        name: "Government Medical College, Ambikapur",
        points: [
          "Modern campus with expanding student intake and infrastructure.",
        ],
      },
      {
        name: "Government Medical College, Kanker & Korba",
        points: [
          "Newly established colleges helping increase seat availability.",
        ],
      },
    ],

    ninthHeading: "Reservation Policy in Chhattisgarh",
    ninthPara:
      "  Chhattisgarh follows a well-defined reservation policy for state quota seats:",
    sevenOl: [
      { title: "SC", description: "12%" },
      { title: "ST", description: "32%" },
      { title: "OBC (non-creamy layer)", description: "14%" },
      { title: "EWC", description: "10%" },
      {
        title: "PWD (Persons with Disabilities)",
        description: "5% horizontal reservation",
      },
    ],

    tenthHeading: "  Scholarships & Financial Assistance",
    tenthPara:
      "  Chhattisgarh students from economically weaker backgrounds can avail of multiple scholarship options:",
    eighthOlHeading: "  Top Government Medical Colleges:",
    eighthOl: [
      "Post-Matric Scholarships for SC/ST/OBC",
      "Government Medical College, Bilaspur",
      "Chief Minister’s Medhavi Vidyarthi Yojana",
      "Government Medical College, Ambikapur",
      "National Scholarships Portal (NSP)",
      "Education Loans from nationalized banks for MBBS education",
    ],
    eighthOlSubheading:
      " These schemes cover tuition fees, hostel charges, and provide monthly stipends.",
    eleventhHeading: " Tips for MBBS Aspirants in Chhattisgarh",
    ninthOlHeading: "Top Government Medical Colleges:",
    ninthOl: [
      {
        title: "Start NEET Prep Early:",
        description: "Your score is the key to all types of admission.",
      },
      {
        title: "Check Official Sites",
        description:
          "Regularly visit https://cgdme.admissions.nic.in and https://mcc.nic.in.",
      },
      {
        title: "Avoid Fraudulent Agents",
        description: "Always verify admission sources.",
      },
      {
        title: "Document Checklist:",
        description:
          "Keep all certificates, mark sheets, and NEET scorecard ready.",
      },
      {
        title: "National Scholarships Portal (NSP)",
        description: "",
      },
      {
        title: "Be Aware of Deadlines",
        description: "Missing a counselling round can cost a whole year.",
      },
    ],
    conclusion: `<b className="text-[#f78c1f]">MBBS in Chhattisgarh</b> offers a
                  viable path for both state residents and All India students
                  through government quota, private colleges, and{" "}
                  <b>management quota options.</b> With NEET as a mandatory
                  requirement, students with moderate scores can still gain
                  <span>
                    admission through direct or management quota seats,
                  </span>{" "}
                  especially in private institutions like RIMS and SSIMS. The
                  state's transparent admission process, increasing seat count, and
                  balanced mix of affordability and infrastructure make it an
                  excellent choice for aspiring doctors in 2026 and beyond. If
                  you're looking for personalized guidance on documentation,
                  counselling registration, or direct MBBS admission in
                  Chhattisgarh, feel free to ask!`,
  },

  {
    locationName: "Delhi",
    title: "MBBS in Delhi",
    metaTitle: "Direct MBBS in Chhattisgarh",
    metaDescription: "MBBS Admisison in Chhattisgarh in Top Medical Colleges",
    metaKeywords:
      "MBBS Admission Through Management Quota in Chhattisgarh , Direct MBBS in Chhattisgarh ,MBBS Admisison in Chhattisgarh in Top Medical Colleges",
    secondHeading: "Complete Guide for 2026 Aspirants",
    secondPara: ` Delhi, the national capital of India, is not only a hub of politics and business but also one of the most prestigious locations for medical education. The city hosts several renowned government and private medical colleges offering MBBS programs. Known for academic excellence, superior infrastructure, and top-tier hospitals, MBBS in Delhi is highly competitive and aspirational for students across the country. <br />
This article provides detailed insights into <b> MBBS </b> admission in <b> Delhi <b />,  including <b> direct admission, management quota, NEET requirements</b>,  and a list of  <b>top medical colleges.</b>`,
    thirdHeading: ` Overview of <b>MBBS in Chhattisgarh</b>`,
    thirdPara: `    MBBS (Bachelor of Medicine and Bachelor of Surgery) is a
                    five-and-a-half-year professional undergraduate medical
                    program that includes one year of mandatory internship. The
                    program is governed by the
                    <b>National Medical Commission (NMC)</b>, and the
                    <b>
                    
                      Directorate of Medical Education, Chhattisgarh (DME-CG)
                    </b>
                    is responsible for admissions in the state.`,
    fourthPara: `    With around <b> 1,500+ MBBS</b> seats in both government
                      and private colleges, Chhattisgarh offers a competitive
                      yet attainable route to a medical career, especially for
                      NEET-qualified candidates from across India.`,
    eligibilityCriteria: [
      {
        icon: "line-icon-Male-2 text-gradient bg-[#194297]",
        title: "Age:",
        content:
          "Minimum of 17 years as of 31st December of the admission year",
      },
      {
        icon: "line-icon-Book text-gradient bg-[#194297]",
        title: "Academic Qualification",
        content:
          "10+2 or equivalent with Physics, Chemistry, Biology/Biotechnology, and English.",
      },
      {
        icon: " line-icon-Target text-gradient bg-[#194297]",
        title: "Minimum Marks:",
        content: "General category: 50% in PCB,  OBC/SC/ST: 40%, PwD: 45%",
      },
      {
        icon: "line-icon-University-2 text-gradient bg-[#194297]",
        title: "NEET-UG Qualification",
        content:
          "Mandatory for all categories, including management and NRI quotas",
      },
    ],
    fifthHeading: " Admission Process for MBBS in Chhattisgarh",
    fifthPara: `    The <b>MBBS admission in Chhattisgarh </b>is conducted through
                centralized online counselling managed by the Directorate of
                Medical Education, Raipur (CGDME) via the official portal
                <a
                  className="mx-2 text-blue-500"
                  href="https://cgdme.admissions.nic.in."
                >
                  https://cgdme.admissions.nic.in.
                </a>`,
    firstOlHeading: "Seat Categories:",
    firstOl: [
      {
        title: "State Quota (85%)",
        description: "For Chhattisgarh domicile students.",
      },
      {
        title: "All India Quota (15%)",
        description: "Conducted by MCC for government colleges.",
      },
      {
        title: "NRI Quota",
        description:
          "Reserved for foreign nationals and NRIs in some private colleges.",
      },
    ],
    secondOlHeading: "Steps in the Admission Process:",
    secondOl: [
      {
        title: "NEET Qualification",
        description: "Appear and qualify in NEET-UG.",
      },
      {
        title: "Online Registration",
        description: "Register on CGDME portal for counselling.",
      },
      {
        title: "Document Verification",
        description: "Online or offline as notified.",
      },
      {
        title: "Choice Filling",
        description:
          "Select preferred colleges and quota (government, private, management).",
      },
      {
        title: "Seat Allotment",
        description: "Based on NEET rank, category, and availability.",
      },
      {
        title: "Reporting & Fee Payment",
        description: "Confirm seat and join the allotted college.",
      },
    ],

    sixthHeading: "MBBS Admission Through Management Quota in Chhattisgarh",
    sixthPara:
      " Private medical colleges in Chhattisgarh offer management quota seats, providing a valuable option for students who have qualified NEET but have lower ranks.",
    thirdOlHeading: "Key Features:",
    thirdOl: [
      {
        title: "Open to All India Candidates",
        description: "No domicile requirement.",
      },
      {
        title: "NEET Mandatory",
        description:
          "Even under management quota, NEET qualification is compulsory.",
      },
      {
        title: "Higher Fee Structure",
        description:
          "Typically higher than government and regular private seats.",
      },
      {
        title: "Transparent Counselling",
        description: "Conducted via the same CGDME portal.",
      },
    ],
    fourthOlHeading: "Required Documents:",
    fourthOl: [
      "NEET-UG scorecard",
      "Class 10 and 12 mark sheets and certificates",
      "Transfer and migration certificate",
      "ID proof (Aadhaar/Passport)",
      "Passport-size photographs",
      "Domicile certificate (if applicable)",
      "Category and income certificates (if applicable)",
    ],
    fourthOlNote: `   Management quota seats are filled through counseling, not direct
                negotiation with colleges. Always apply through official
                portals.`,
    sevenHeading: "   Direct MBBS Admission in Chhattisgarh",
    sevenPara: `   <b> “Direct MBBS Admission” </b>usually refers to securing a
                  seat without the regular merit-based competition, commonly
                  through management or NRI quotas. However, NEET qualification
                  is still mandatory.`,

    fifthOlHeading: "  How Direct Admission Works:",
    fifthOl: [
      "Available only in private medical colleges.",
      "Seats that remain vacant after initial counselling rounds may be offered directly.",
      "Admission facilitated by college-authorized admission desks or counselling consultants, but still must be reported through the CGDME system.",
      "Fees are payable upfront and are generally non-refundable.",
    ],
    eighthHeading: "  Top Medical Colleges in Chhattisgarh",
    eighthPara: ` Chhattisgarh has both reputed government and private medical
                institutions. Here’s a look at the best options for MBBS
                aspirants:`,
    sixthOlHeading: "Top Government Medical Colleges:",
    sixthOl: [
      {
        name: "Pt. Jawahar Lal Nehru Memorial Medical College, Raipur",
        points: [
          "Premier government institution with strong academics and clinical exposure.",
          "High patient inflow and excellent faculty.",
        ],
      },
      {
        name: "Government Medical College, Bilaspur",
        points: [
          "Established recently but fast-growing in reputation.",
          "Good facilities and practical training.",
        ],
      },
      {
        name: "Late Baliram Kashyap Memorial Medical College, Jagdalpur",
        points: [
          "Serves tribal regions; good clinical exposure and public health training.",
        ],
      },
      {
        name: "Government Medical College, Ambikapur",
        points: [
          "Modern campus with expanding student intake and infrastructure.",
        ],
      },
      {
        name: "Government Medical College, Kanker & Korba",
        points: [
          "Newly established colleges helping increase seat availability.",
        ],
      },
    ],

    ninthHeading: "Reservation Policy in Chhattisgarh",
    ninthPara:
      "  Chhattisgarh follows a well-defined reservation policy for state quota seats:",
    sevenOl: [
      { title: "SC", description: "12%" },
      { title: "ST", description: "32%" },
      { title: "OBC (non-creamy layer)", description: "14%" },
      { title: "EWC", description: "10%" },
      {
        title: "PWD (Persons with Disabilities)",
        description: "5% horizontal reservation",
      },
    ],

    tenthHeading: "  Scholarships & Financial Assistance",
    tenthPara:
      "  Chhattisgarh students from economically weaker backgrounds can avail of multiple scholarship options:",
    eighthOlHeading: "  Top Government Medical Colleges:",
    eighthOl: [
      "Post-Matric Scholarships for SC/ST/OBC",
      "Government Medical College, Bilaspur",
      "Chief Minister’s Medhavi Vidyarthi Yojana",
      "Government Medical College, Ambikapur",
      "National Scholarships Portal (NSP)",
      "Education Loans from nationalized banks for MBBS education",
    ],
    eighthOlSubheading:
      " These schemes cover tuition fees, hostel charges, and provide monthly stipends.",
    eleventhHeading: " Tips for MBBS Aspirants in Chhattisgarh",
    ninthOlHeading: "Top Government Medical Colleges:",
    ninthOl: [
      {
        title: "Start NEET Prep Early:",
        description: "Your score is the key to all types of admission.",
      },
      {
        title: "Check Official Sites",
        description:
          "Regularly visit https://cgdme.admissions.nic.in and https://mcc.nic.in.",
      },
      {
        title: "Avoid Fraudulent Agents",
        description: "Always verify admission sources.",
      },
      {
        title: "Document Checklist:",
        description:
          "Keep all certificates, mark sheets, and NEET scorecard ready.",
      },
      {
        title: "National Scholarships Portal (NSP)",
        description: "",
      },
      {
        title: "Be Aware of Deadlines",
        description: "Missing a counselling round can cost a whole year.",
      },
    ],
    conclusion: `<b className="text-[#f78c1f]">MBBS in Chhattisgarh</b> offers a
                  viable path for both state residents and All India students
                  through government quota, private colleges, and{" "}
                  <b>management quota options.</b> With NEET as a mandatory
                  requirement, students with moderate scores can still gain
                  <span>
                    admission through direct or management quota seats,
                  </span>{" "}
                  especially in private institutions like RIMS and SSIMS. The
                  state's transparent admission process, increasing seat count, and
                  balanced mix of affordability and infrastructure make it an
                  excellent choice for aspiring doctors in 2026 and beyond. If
                  you're looking for personalized guidance on documentation,
                  counselling registration, or direct MBBS admission in
                  Chhattisgarh, feel free to ask!`,
  },
];
